export const CRITERIA: {
  [key in string]: {
    isCta: boolean
    isProjectOnly: boolean
    isFree: boolean
    showOutdated: boolean
    showInDudaEditor: boolean
    showExtraAdviceForDudaEditor: boolean
  }
} = {
  title: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  description: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  google_preview: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  headings: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  keywords_cloud: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  image_optimization: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  images: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  links_details: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  language: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  web_feeds: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  www_resolve: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  robots_txt: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  xml_sitemaps: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  sitemaps_validity: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  clean_url: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  canonical_tags: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  noindex_nofollow: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  robots_tags: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  hreflang: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  broken_links: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  underscores_url: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  indexed_pages: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  mobile_friendliness: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_rendering: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_taptargets: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  mobile_compatibility: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_fontsize: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  mobile_viewport: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_frameworks: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  amp: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  schema_org: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  open_graph: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  twitter_card: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  microformats: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  email_security: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  dmarc: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  ssl_secured: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  mixed_content: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  resources_minification: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  resources_compression: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  resources_cacheability: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  layout_shift_elements: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  largest_contentful_paint_element: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  accessibility_contrast: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  accessibility_navigation: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  pj_uptime: {
    isCta: true,
    isProjectOnly: true,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  ip_information: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  technologies: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  analytics_technologies: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  doctype: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  encoding: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  url: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  favicon: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  custom_404: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  domain_registration: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  tld_cybersquating_prevention: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  typo_cybersquating_prevention: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  backlinks_score: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  backlinks_counter: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  backlinks_ref_domains: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  pj_backlinks_quality: {
    isCta: true,
    isProjectOnly: true,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_engagement: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_estimation: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_monthly_visits: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_popularity: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_sources: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_top_countries: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  local_directories: {
    isCta: true,
    isProjectOnly: false,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  local_online_reviews: {
    isCta: false,
    isProjectOnly: false,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  shared_count: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  facebook_brand_page: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  twitter_account: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  instagram: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  linkedin: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  crunchbase: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  discovered_social_profiles: {
    isCta: false,
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  gwt_queries: {
    isCta: false,
    isProjectOnly: true,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  }
};
